import type { DailyClip, StreakSummary } from '@proref/types';
import { api, unwrap, type Envelope } from '../lib/api';

// The signed-in referee's clip for today — the full playable payload (signed URL) plus whether
// they've answered it. Scoped to the caller by their JWT; the server assigns one lazily if the
// 03:00 job hasn't run yet.
export async function getDailyClip(): Promise<DailyClip> {
  const res = await api.get<Envelope<DailyClip>>('/me/daily');
  return unwrap(res.data);
}

// The referee's current streak + whether today's clip is already answered.
export async function getStreak(): Promise<StreakSummary> {
  const res = await api.get<Envelope<StreakSummary>>('/me/streak');
  return unwrap(res.data);
}
